import Strings from "../../utils/stringUtil";

export const accordionsQA = [
  {
    key: "panel1",
    question: Strings.faqLoanSection,
    nested: [
      {
        key: "faqLoanQ1",
        question: Strings.faqLoanQ1,
        answer: Strings.faqLoanA1,
      },
      {
        key: "faqLoanQ2",
        question: Strings.faqLoanQ2,
        answer: Strings.faqLoanA2,
      },
      {
        key: "faqLoanQ3",
        question: Strings.faqLoanQ3,
        answer: Strings.faqLoanA3,
      },
      {
        key: "faqLoanQ4",
        question: Strings.faqLoanQ4,
        answer: Strings.faqLoanA4,
      },
      {
        key: "faqLoanQ5",
        question: Strings.faqLoanQ5,
        answer: Strings.faqLoanA5,
      },
      {
        key: "faqLoanQ6",
        question: Strings.faqLoanQ6,
        answer: Strings.faqLoanA6,
      },
      {
        key: "faqLoanQ7",
        question: Strings.faqLoanQ7,
        answer: Strings.faqLoanA7,
      },
      {
        key: "faqLoanQ8",
        question: Strings.faqLoanQ8,
        answer: Strings.faqLoanA8,
      },
      {
        key: "faqLoanQ9",
        question: Strings.faqLoanQ9,
        answer: Strings.faqLoanA9,
      },
      {
        key: "faqLoanQ10",
        question: Strings.faqLoanQ10,
        answer: Strings.faqLoanA10,
      },
      {
        key: "faqLoanQ11",
        question: Strings.faqLoanQ11,
        answer: Strings.faqLoanA11,
      },
      {
        key: "faqLoanQ12",
        question: Strings.faqLoanQ12,
        answer: Strings.faqLoanA12,
      },
      {
        key: "faqLoanQ13",
        question: Strings.faqLoanQ13,
        answer: Strings.faqLoanA13,
      },
      {
        key: "faqLoanQ14",
        question: Strings.faqLoanQ14,
        answer: Strings.faqLoanA14,
      },
      {
        key: "faqLoanQ15",
        question: Strings.faqLoanQ15,
        answer: Strings.faqLoanA15,
      },
      {
        key: "faqLoanQ16",
        question: Strings.faqLoanQ16,
        answer: Strings.faqLoanA16,
      },
      {
        key: "faqLoanQ17",
        question: Strings.faqLoanQ17,
        answer: Strings.faqLoanA17,
      },
      {
        key: "faqLoanQ18",
        question: Strings.faqLoanQ18,
        answer: Strings.faqLoanA18,
      },
      {
        key: "faqLoanQ19",
        question: Strings.faqLoanQ19,
        answer: Strings.faqLoanA19,
      },
      {
        key: "faqLoanQ20",
        question: Strings.faqLoanQ20,
        answer: Strings.faqLoanA20,
      },
      {
        key: "faqLoanQ21",
        question: Strings.faqLoanQ21,
        answer: Strings.faqLoanA21,
      },
      {
        key: "faqLoanQ22",
        question: Strings.faqLoanQ22,
        answer: Strings.faqLoanA22,
      },
      {
        key: "faqLoanQ23",
        question: Strings.faqLoanQ23,
        answer: Strings.faqLoanA23,
      },
      {
        key: "faqLoanQ24",
        question: Strings.faqLoanQ24,
        answer: Strings.faqLoanA24,
      },
      {
        key: "faqLoanQ25",
        question: Strings.faqLoanQ25,
        answer: Strings.faqLoanA25,
      },
      {
        key: "faqLoanQ26",
        question: Strings.faqLoanQ26,
        answer: Strings.faqLoanA26,
      },
      {
        key: "faqLoanQ27",
        question: Strings.faqLoanQ27,
        answer: Strings.faqLoanA27,
      },
      {
        key: "faqLoanQ28",
        question: Strings.faqLoanQ28,
        answer: Strings.faqLoanA28,
      },
      {
        key: "faqLoanQ29",
        question: Strings.faqLoanQ29,
        answer: Strings.faqLoanA29,
      },
      {
        key: "faqLoanQ30",
        question: Strings.faqLoanQ30,
        answer: Strings.faqLoanA30,
      },
      {
        key: "faqLoanQ31",
        question: Strings.faqLoanQ31,
        answer: Strings.faqLoanA31,
      },
      {
        key: "faqLoanQ33",
        question: Strings.faqLoanQ33,
        answer: Strings.faqLoanA33,
      },
      {
        key: "faqLoanQ34",
        question: Strings.faqLoanQ34,
        answer: Strings.faqLoanA34,
      },
      {
        key: "faqLoanQ35",
        question: Strings.faqLoanQ35,
        answer: Strings.faqLoanA35,
      },
      {
        key: "faqLoanQ36",
        question: Strings.faqLoanQ36,
        answer: Strings.faqLoanA36,
      },
      {
        key: "faqLoanQ37",
        question: Strings.faqLoanQ37,
        answer: Strings.faqLoanA37,
      },
      {
        key: "faqLoanQ38",
        question: Strings.faqLoanQ38,
        answer: Strings.faqLoanA38,
      },
      {
        key: "faqLoanQ39",
        question: Strings.faqLoanQ39,
        answer: Strings.faqLoanA39,
      },
      {
        key: "faqLoanQ40",
        question: Strings.faqLoanQ40,
        answer: Strings.faqLoanA40,
      },
      {
        key: "faqLoanQ41",
        question: Strings.faqLoanQ41,
        answer: Strings.faqLoanA41,
      },
      {
        key: "faqLoanQ42",
        question: Strings.faqLoanQ42,
        answer: Strings.faqLoanA42,
      },
      {
        key: "faqLoanQ43",
        question: Strings.faqLoanQ43,
        answer: Strings.faqLoanA43,
      },
      {
        key: "faqLoanQ44",
        question: Strings.faqLoanQ44,
        answer: Strings.faqLoanA44,
      },
      {
        key: "faqLoanQ45",
        question: Strings.faqLoanQ45,
        answer: Strings.faqLoanA45,
      },
      {
        key: "faqLoanQ46",
        question: Strings.faqLoanQ46,
        answer: Strings.faqLoanA46,
      },
      {
        key: "faqLoanQ47",
        question: Strings.faqLoanQ47,
        answer: Strings.faqLoanA47,
      },
      {
        key: "faqLoanQ48",
        question: Strings.faqLoanQ48,
        answer: Strings.faqLoanA48,
      },
      {
        key: "faqLoanQ49",
        question: Strings.faqLoanQ49,
        answer: Strings.faqLoanA49,
      },
      {
        key: "faqLoanQ50",
        question: Strings.faqLoanQ50,
        answer: Strings.faqLoanA50,
      },
      {
        key: "faqLoanQ51",
        question: Strings.faqLoanQ51,
        answer: Strings.faqLoanA51,
      },
      {
        key: "faqLoanQ52",
        question: Strings.faqLoanQ52,
        answer: Strings.faqLoanA52,
      },
      {
        key: "faqLoanQ53",
        question: Strings.faqLoanQ53,
        answer: Strings.faqLoanA53,
      },
      {
        key: "faqLoanQ54",
        question: Strings.faqLoanQ54,
        answer: Strings.faqLoanA54,
      },
      {
        key: "faqLoanQ55",
        question: Strings.faqLoanQ55,
        answer: Strings.faqLoanA55,
      },
      {
        key: "faqLoanQ56",
        question: Strings.faqLoanQ56,
        answer: Strings.faqLoanA56,
      },
      {
        key: "faqLoanQ57",
        question: Strings.faqLoanQ57,
        answer: Strings.faqLoanA57,
      },
      {
        key: "faqLoanQ58",
        question: Strings.faqLoanQ58,
        answer: Strings.faqLoanA58,
      },
    ],
  },
  {
    key: "panel2",
    question: Strings.faqEventSection,
    nested: [
      {
        key: "faqEventQ1",
        question: Strings.faqEventQ1,
        answer: Strings.faqEventA1,
      },
      {
        key: "faqEventQ2",
        question: Strings.faqEventQ2,
        answer: Strings.faqEventA2,
      },
      {
        key: "faqEventQ3",
        question: Strings.faqEventQ3,
        answer: Strings.faqEventA3,
      },
      {
        key: "faqEventQ4",
        question: Strings.faqEventQ4,
        answer: Strings.faqEventA4,
      },
      {
        key: "faqEventQ5",
        question: Strings.faqEventQ5,
        answer: Strings.faqEventA5,
      },
      {
        key: "faqEventQ6",
        question: Strings.faqEventQ6,
        answer: Strings.faqEventA6,
      },
      {
        key: "faqEventQ7",
        question: Strings.faqEventQ7,
        answer: Strings.faqEventA7,
      },
    ],
  },
  {
    key: "panel5",
    question: Strings.faqSignUpProfileSection,
    nested: [
      {
        key: "faqSignupQ1",
        question: Strings.faqSignupQ1,
        answer: Strings.faqSignupA1,
      },
      {
        key: "faqSignupQ3",
        question: Strings.faqSignupQ3,
        answer: Strings.faqSignupA3,
      },
      {
        key: "faqSignupQ4",
        question: Strings.faqSignupQ4,
        answer: Strings.faqSignupA4,
      },
      {
        key: "faqSignupQ5",
        question: Strings.faqSignupQ5,
        answer: Strings.faqSignupA5,
      },
    ],
  },
  {
    key: "panel8",
    question: Strings.faqMahilaMoneyPinSection,
    nested: [
      {
        key: "faqMahilaMoneyPinQ1",
        question: Strings.faqMahilaMoneyPinQ1,
        answer: Strings.faqMahilaMoneyPinA1,
      },
      {
        key: "faqMahilaMoneyPinQ2",
        question: Strings.faqMahilaMoneyPinQ2,
        answer: Strings.faqMahilaMoneyPinA2,
      },
    ],
  },
  {
    key: "panel9",
    question: Strings.faqlendingPartnersDetailsSection,
    nested: [
      {
        key: "faqLendingPartnersDetailsQ1",
        question: Strings.faqLendingPartnersDetailsQ1,
        answer: Strings.faqLendingPartnersDetailsA1,
      },
      {
        key: "faqLendingPartnersDetailsQ2",
        question: Strings.faqLendingPartnersDetailsQ2,
        answer: Strings.faqLendingPartnersDetailsA2,
      },
    ],
  },
  {
    key: "panel10",
    question: Strings.faqGrievanceSection,
    nested: [
      {
        key: "faqGrievancesQ1",
        question: Strings.faqGrievancesQ1,
        answer: Strings.faqGrievancesA1,
      },
    ],
  },
  {
    key: "panel11",
    question: Strings.faqOthersSection,
    nested: [
      {
        key: "faqOthersQ1",
        question: Strings.faqOthersQ1,
        answer: Strings.faqOthersA1,
      },
      {
        key: "faqOthersQ3",
        question: Strings.faqOthersQ3,
        answer: Strings.faqOthersA3,
      },
      {
        key: "faqOthersQ4",
        question: Strings.faqOthersQ4,
        answer: Strings.faqOthersA4,
      },
      {
        key: "faqOthersQ6",
        question: Strings.faqOthersQ6,
        answer: Strings.faqOthersA6,
      },
      {
        key: "faqOthersQ7",
        question: Strings.faqOthersQ7,
        answer: Strings.faqOthersA7,
      },
    ],
  },
];
